/**
 * @generated SignedSource<<7adced7e0bd5f0e1fc29b24915d34f69>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type InvitePage_viewer$data = {
  readonly account: {
    readonly domains: ReadonlyArray<{
      readonly aliases: ReadonlyArray<string>;
      readonly domain: string;
    }>;
  };
  readonly questionAnswers: any | null;
  readonly syncReady: boolean | null;
  readonly user: {
    readonly email: string;
    readonly fullName: string;
    readonly id: string;
    readonly internalAttributes: {
      readonly isAccountCreator: boolean;
    } | null;
  };
  readonly " $fragmentType": "InvitePage_viewer";
};
export type InvitePage_viewer$key = {
  readonly " $data"?: InvitePage_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"InvitePage_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InvitePage_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "questionAnswers",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "syncReady",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "fullName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "email",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "UserInternalAttributes",
          "kind": "LinkedField",
          "name": "internalAttributes",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isAccountCreator",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Account",
      "kind": "LinkedField",
      "name": "account",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EmailDomain",
          "kind": "LinkedField",
          "name": "domains",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "domain",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "aliases",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "9dd6d8421630863d23291cb84fa6eefd";

export default node;
